import { ThunkAction } from 'redux-thunk';
import { AxiosResponse } from 'axios';
import store from 'store';
import ApiClient, { createTokenConfig, isCancelled } from 'api/ApiClient';
import { NotificationsAction, showError } from '@spike/notifications-action';
import {
    CANCELLATION_NO_SHOWS_REPORT_GET_START,
    CANCELLATION_NO_SHOWS_REPORT_GET_SUCCESS,
    CANCELLATION_NO_SHOWS_REPORT_GET_ERROR,
    CancellationAndNoShowsReportAction
} from './CancellationAndNoShowsReportActionsTypes';
import { CancellationAndNoShowsReportDto } from './CancellationAndNoShowsReportDto';
import { convertToCancellationAndNoShowsReport } from './cancellationAndNoShowsReportConverter';

export const getCancellationAndNoShowsReport = (
    start?: string,
    end?: string
): ThunkAction<void, null, null, CancellationAndNoShowsReportAction | NotificationsAction> => {
    return async dispatch => {
        dispatch(getStart());

        const state = store.getState();
        const { marketplaceId, token, timeZone } = state.login.auth;

        let url = `/cancellation_and_no_shows_report?marketplace_id=${marketplaceId}`;
        if (start) url += `&start_date=${start}`;
        if (end) url += `&end_date=${end}`;

        try {
            const response: AxiosResponse<CancellationAndNoShowsReportDto> = await ApiClient.get(
                url,
                createTokenConfig(token!)
            );

            dispatch(getSuccess(response.data, timeZone!));
        } catch (apiError) {
            if (!isCancelled(apiError)) {
                dispatch(getError());
                dispatch(showError('Too many records to display. Please try a shorter date range.'));
            }
        }
    };
};

const getStart = (): CancellationAndNoShowsReportAction => ({
    type: CANCELLATION_NO_SHOWS_REPORT_GET_START
});

const getSuccess = (dto: CancellationAndNoShowsReportDto, timeZone: string): CancellationAndNoShowsReportAction => ({
    type: CANCELLATION_NO_SHOWS_REPORT_GET_SUCCESS,
    payload: {
        report: convertToCancellationAndNoShowsReport(dto, timeZone)
    }
});

const getError = (): CancellationAndNoShowsReportAction => ({
    type: CANCELLATION_NO_SHOWS_REPORT_GET_ERROR
});
